import React from 'react';

const site = () => window._env_?.PUBLIC_WEBSITE || 'https://www.fiche-sante.fr';

const LEGAL_TYPES = {
    cgu: { label: "les Conditions Générales d'Utilisation", page: 'cgu.html' },
    dpa: { label: "l'Annexe RGPD (accord de sous-traitance, art. 28)", page: 'annexe-rgpd.html' },
};

/** Une case non précochée par document, avec la date du document affichée et le lien vers la page publique. */
const LegalCheckboxes = ({ docs, types, checked, onChange }) => (
    <>
        {types.map((type) => (
            <div className="form-group legal-check" key={type}>
                <label>
                    <input
                        type="checkbox"
                        name={`accept_${type}`}
                        checked={!!checked[type]}
                        onChange={(e) => onChange(type, e.target.checked)}
                    />{' '}
                    J'ai lu et j'accepte {LEGAL_TYPES[type].label} (du {docs[type].date}){' '}
                    <a href={`${site()}/${LEGAL_TYPES[type].page}`} target="_blank" rel="noopener noreferrer">
                        lire le document
                    </a>
                </label>
            </div>
        ))}
    </>
);

export default LegalCheckboxes;
